/*
	[ Low-volatile ] fields:
	- These fields values change rare, sometimes only.
 */

import { Model } from "@models";

export class AssetSettings extends Model {
	protected available: boolean = false;
	protected buy_active: boolean = false;
	protected deposit_active: boolean = false;
	protected index_only: boolean = false;
	protected maintenance_enabled: boolean = false;
	protected min_buy_eur: number = 0;
	protected min_sell_eur: number = 0;
	protected min_withdrawal: string = "";
	protected sell_active: boolean = false;
	protected sort: number = 0;
	protected transfer_active: boolean = true;
	protected wallet_min_deposit: string = "";
	protected wallet_small_deposit: string = "";
	protected wallet_small_deposit_fee: string = "";
	protected withdraw_active: boolean = false;
	protected automated_order_active: boolean = false;

	public isAvailable(): boolean {
		return this.available;
	}

	public isBuyActive(): boolean {
		return this.buy_active;
	}

	public isPriceOrderAvailable(): boolean {
		return this.automated_order_active;
	}

	public isIndexOnly(): boolean {
		return this.index_only;
	}

	public isMaintenance(): boolean {
		return this.maintenance_enabled;
	}

	public getMinBuy(): number {
		return this.min_buy_eur;
	}

	public getMinSell(): number {
		return this.min_sell_eur;
	}

	public getMinWithdrawal(): number {
		return +this.min_withdrawal;
	}

	public isSellActive(): boolean {
		return this.sell_active;
	}

	public getSort(): number {
		return this.sort;
	}

	public isDepositActive(): boolean {
		return this.deposit_active;
	}

	public isTransferActive(): boolean {
		return this.transfer_active;
	}

	public getWalletMinDeposit(): number {
		return +this.wallet_min_deposit;
	}

	public getSmallDeposit(): number {
		return +this.wallet_small_deposit;
	}

	public getSmallDepositFee(): number {
		return +this.wallet_small_deposit_fee;
	}

	public isWithdrawActive(): boolean {
		return this.withdraw_active;
	}
}
